import * as z$1 from "zod/v4";
//#region src/schemas/http/agent-profile-execution-mode.ts
const agentProfileExecutionModeSchema = z$1.enum(["parallel", "serial"]);
const updateAgentProfileExecutionModeBodySchema = z$1.object({ mode: agentProfileExecutionModeSchema }).strict();
const agentProfileExecutionModeResponseSchema = z$1.object({
	agentProfileId: z$1.string().min(1),
	mode: agentProfileExecutionModeSchema,
	migration: z$1.enum([
		"legacy",
		"draining",
		"contexts"
	]),
	revision: z$1.number().int().nonnegative()
}).strict();
const runtimeTransportAgentProfileExecutionModeRequestSchema = z$1.object({
	ownerUserId: z$1.string().min(1),
	targetProfileId: z$1.string().min(1),
	mode: agentProfileExecutionModeSchema.optional()
}).strict();
//#endregion
export { agentProfileExecutionModeResponseSchema, agentProfileExecutionModeSchema, runtimeTransportAgentProfileExecutionModeRequestSchema, updateAgentProfileExecutionModeBodySchema };

//# sourceMappingURL=agent-profile-execution-mode.js.map